<template>
    <rkm-area
        no-margin-top
        title="Encerramento da gestação"
    >
        <rkm-row>
            <rkm-col cols="4">
                <Item
                    :get-value="() => item.preNatal.gravidezTipo.nome"
                    label="Tipo de gravidez"
                />
            </rkm-col>

            <rkm-col cols="4">
                <Item
                    :get-value="() => item.preNatal.desfechoEm"
                    label="Data do desfecho"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {Item},
    props: {
        item: {type: Object, required: true},
    },
}
</script>